var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn",attrs:{"href":"weixin://dl/business/?t=6MRRQRLnw0r"}},[_vm._v("打开小程序")])])
}]

export { render, staticRenderFns }